// Imágenes complementarias de la capa de marketing.
//
// Fuente: Unsplash (https://unsplash.com) — Unsplash License, uso comercial
// gratuito. A diferencia de la primera versión (que enlazaba por ID al CDN de
// Unsplash y provocó imágenes equivocadas o rotas), ahora las imágenes se
// DESCARGARON y VERIFICARON una a una, y se sirven desde `public/img/` del
// propio sitio. Así garantizamos que cada imagen existe y corresponde al tema.
// Créditos en frontend/design/IMAGE-CREDITS.md.

/** Banco de imágenes royalty-free (locales en /img), todas verificadas. */
export const IMG = {
  /** Tocadiscos con brazo/aguja apoyada sobre el vinilo (close-up). */
  turntable: '/img/turntable-stylus.jpg',
  /** Disco girando, vista cenital en blanco y negro (dramático, para héroe). */
  spinning: '/img/spinning-topdown.jpg',
  /** Fila de vinilos junto a unos audífonos (colección + escucha). */
  recordsHeadphones: '/img/records-headphones.jpg',
  /** Mano sosteniendo un disco con su etiqueta visible (ingreso por foto). */
  holdingRecord: '/img/holding-record.jpg',
  /** Vinilos de colores (amarillo/violeta) con fundas — vibrante, llamativo. */
  coloredVinyl: '/img/colored-vinyl.jpg',
  /** Vinilos de colores apilados con carátulas (vertical, muy colorido). */
  coloredStack: '/img/colored-vinyl-stack.jpg',
} as const;

export type ImageKey = keyof typeof IMG;
